import { faImage } from '@fortawesome/free-regular-svg-icons';

export default [faImage];
